/**
 * Checks for a non-empty string without trimming or normalizing its contents.
 *
 * @example
 * isNonEmptyString('token'); // true
 */
export const isNonEmptyString = (value) => typeof value === 'string' && value.length > 0;
/**
 * Checks that an array contains at least one element.
 *
 * @example
 * isNonEmptyArray(['token']); // true
 */
export const isNonEmptyArray = (values) => values.length > 0;
/**
 * Checks uniqueness using Set equality; an empty array is unique.
 *
 * @example
 * isUniqueArray(['token', 'token']); // false
 */
export const isUniqueArray = (values) => new Set(values).size === values.length;
/**
 * Checks that an array is both non-empty and unique.
 *
 * @example
 * isUniqueNonEmptyArray(['token']); // true
 */
export const isUniqueNonEmptyArray = (values) => isNonEmptyArray(values) && isUniqueArray(values);
/**
 * Checks non-empty string elements, a non-empty array, and case-sensitive uniqueness.
 *
 * @example
 * isUniqueNonEmptyArrayOfNonEmptyString(['token', 'Token']); // true
 */
export const isUniqueNonEmptyArrayOfNonEmptyString = (values) => {
    if (isUniqueNonEmptyArray(values)) {
        for (const value of values) {
            if (!isNonEmptyString(value)) {
                return false;
            }
        }
        return true;
    }
    return false;
};
//# sourceMappingURL=nonEmpty.js.map